import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHTML',
  pure: false
})
export class SanitizeHTMLPipe implements PipeTransform {

  /**
   * Constructor
   *
   * @param {DomSanitizer} sanitizer
   */
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Transform
   *
   * @param html HTML string to sanitize
   * @returns sanitized HTML
   */
  transform(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
